import PrimeVueDirectives from './PrimeVue/';

export default [...PrimeVueDirectives];